import { MediaElement, MediaShape } from 'editor/src/store/design/types';

const isShape = (element: MediaElement): element is MediaShape =>
  element.type === 'line' || element.type === 'rectangle';

export default isShape;
